import React from 'react';
import { useFranchiseeContext } from '../../context/Franchisee';

const ReviewLinks: React.FC = () => {
  const { franchisee } = useFranchiseeContext();

  if (
    franchisee.id > -1 &&
    (franchisee?.reviewGooglePlusUrl || franchisee?.reviewFacebookUrl)
  ) {
    return (
      <>
        <h1 className='text-center mb-3 h3'>Want to leave us a review?</h1>
        <div className='d-flex justify-content-center flex-row'>
          {/* Add review links Content Here */}

          {franchisee.reviewGooglePlusUrl && (
            <div className='text-center mx-3 my-1'>
              <a
                href={franchisee.reviewGooglePlusUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-primary'
              >
                Review us on Google
              </a>
            </div>
          )}

          {franchisee.reviewFacebookUrl && (
            <div className='text-center mx-3 my-1'>
              <a
                href={franchisee.reviewFacebookUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='btn btn-primary'
              >
                Review us on Facebook
              </a>
            </div>
          )}
        </div>
      </>
    );
  }

  return null;
};

ReviewLinks.defaultProps = {
  // add review links default props here
  className: null,
};

export default ReviewLinks;
